import React from "react";
import {FieldFormValueNotEmpty} from "../../../../proto/components/form/@types";

export default function FieldIcon_FormValueNotEmpty(props:FieldFormValueNotEmpty) {

    const classes = Classes("ui5-ico-14 ", props.field.getDisplayValue(props.value))

    return (
        <React.Fragment>
            <div className={Classes("ui5-txt-default ui5-field-form-editable dropdown-form h-36", props.className)} onClick={props.onClick}>
                <div className={classes} />
            </div>
            {props.children}
        </React.Fragment>
    );
}